import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { IndicatorBox } from "components/DateTime/IndicatorBox";
import { FilterSortTableDashboard } from "components/FilterSortTable/FilterSortTableDashboard";
import { LinkWrapper } from "components/Link/LinkWrapper";
import { TaskLogs } from "components/Logs/TaskLogs/TaskLogs";
import { TaskMeta } from "components/Task/TaskMeta";
import TaskPreviewModal from "components/Task/TaskPreviewModal";
import { SeeMore } from "components/Text/SeeMore";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";

const allowedFilters = [
  { key: "docCode", value: "Task No" },
  { key: "docDetails", value: "Task Document Detail" },
  { key: "taskDescription", value: "Description" },
  { key: "taskDetails", value: "Task Detail" },
  { key: "taskByName", value: "Task by" },
  { key: "taskToName", value: "Task To" },
  { key: "taskToOn", value: "Assigned On" },
  { key: "deadline", value: "Deadline" },
  { key: "acceptanceStatus", value: "Acceptance Status" },
  { key: "doneStatus", value: "Done Status" },
];
export const taskListColumns = ({
  records,
  setOutputRecords,
  openLogModal,
  setOpenLogModal,
  logList,
  setLogList,
  pageName,
}) => [
  { field: "id", headerName: "Id" },
  {
    field: "deadline",
    headerName: "Task Details",
    flex: 1,
    sortable: false,
    renderHeader: (params) => (
      <FlexBox justifyContent="space-between" alignItems="center">
        <FilterSortTableDashboard
          records={records}
          setOutputRecords={setOutputRecords}
          allowedFilters={allowedFilters}
        />
        <Typography>{pageName}</Typography>
      </FlexBox>
    ),
    renderCell: (params) => (
      <FlexBox alignItems="start" justifyContent="space-between">
        <LinkWrapper onClick={() => ""}>
          <IndicatorBox
            targetDate={params.row.deadline}
            alertBeforeDays={params.row.alertBeforeDays}
            key={params.row.id}
          >
            <TaskPreviewModal
              task={{
                title: params.row.docCode,
                docDetails: params.row.docDetails,
                detail: params.row.taskDetails,
                description: params.row.taskDescription,
                taskByName: params.row.taskByName,
                taskToName: params.row.taskToName,
                taskToOn: params.row.taskToOn,
                acceptanceStatus: params.row.acceptanceStatus,
                acceptanceComment: params.row.acceptanceComment,
                acceptanceOn: params.row.acceptanceOn,
                deadline: params.row.deadline,
                doneStatus: params.row.doneStatus,
                doneOn: params.row.doneOn,
                acknowledgeStatus: params.row.acknowledgeStatus,
                acknowledgeOn: params.row.acknowledgeOn,
              }}
            >
              <FlexBox justifyContent="space-between">
                <Box>
                  {params.row.docCode}
                  {params.row.docDetails && "- " + params.row.docDetails}
                </Box>
              </FlexBox>
              <FlexBox justifyContent="space-between">
                <Box>
                  <SeeMore text={params.row.taskDetails} />
                </Box>
              </FlexBox>
            </TaskPreviewModal>
            <TaskMeta
              acceptanceOn={params.row.acceptanceOn}
              acceptanceStatus={params.row.acceptanceStatus}
              deadline={params.row.deadline}
              doneOn={params.row.doneOn}
              doneStatus={params.row.doneStatus}
              taskByName={params.row.taskByName}
              taskDetails={params.row.taskDetails}
              taskToName={params.row.taskToName}
              taskToOn={params.row.taskToOn}
            />
          </IndicatorBox>
        </LinkWrapper>
        <TaskLogs
          id={params.row.id}
          updateCount={params.row.updatesCount}
          openLogModal={openLogModal}
          setOpenLogModal={setOpenLogModal}
          logList={logList}
          setLogList={setLogList}
        />
      </FlexBox>
    ),
  },
];
